import {logout} from "../redux_actions/login.action";
import {store} from "../helper/store";

const userChannel = new BroadcastChannel('user-auth');

userChannel.onmessage = data => {
    if (data.data.payload.type === "SIGN_IN") {
        window.location.reload()
    }
    if (data.data.payload.type === "SIGN_OUT") {
        store.dispatch(logout(null, null, true));
    }
}

export const logoutFromAllTabs = () => {
    userChannel.postMessage({
        payload: {
            type: "SIGN_OUT"
        }
    });
}

export const loginInAllTabs = () => {
    userChannel.postMessage({
        payload: {
            type: "SIGN_IN"
        }
    });
}
